import DashboardService from 'live/services/dashboard'
import OperationsPickerConfig from './components/OperationSpanPicker/OperationConfigs'
import { memoize } from 'lodash'
import OperationsTreeInitializer from './components/DrillingOperationsTree/init'
import SpanComponentTitle from './components/OperationSpanPicker/spanComponentTitle'
import { spanPickerType } from './components/utils/initialStates'

/**
 * The spanPickerRegistry.register is a Live API that registers a new kind of span to be selected for a deashboard
 * @param type {string} - this property defines kind of an id for the span on Live
 * @param name {() => string} - defines the name to be used on live for this span picker
 * @param description {() -> string} - a description to be seen above the name, over the span picker options
 * @param components {
 * dashboardMenuView {JSX.Component} :
 * dashboardMenuEdit {JSX.Component} : A component that will be seen on the edit view of the dashboard, can be really useful to define configurations for the span picker
 * widgetEditor {JSX.Component} : this component will be seen on the widget edit view, and can be useful to change the span of that widget diruing its editting.
 * }
 * @param defaultSpan {string} - A default span to be used on the dashboard.
 * @param getSpanComponenTitle {JSX.Component} - The component that will be seen over the dashboard view part, which can display the current dashboard span
 * @param downloadFormats {string} - a string that defines how will be the download format of the dashboard (?)
 */


DashboardService.spanPickerRegistry.register({
    type: spanPickerType,
    get name() {
        return 'DRILLING OPERATIONS' //i18n('span-picker-depth')
    },
    get description() {
        return 'A tree containing the drilling sections, runs and operations to be selected/checked' //i18n('span-picker-depth-description')
    },
    components: {
        dashboardMenuView: OperationsTreeInitializer,
        dashboardMenuEdit: OperationsPickerConfig,
        widgetEditor: OperationsTreeInitializer 
    },
    defaultSpan: 'last hour',
    getSpanComponentTitle: memoize(
        () => SpanComponentTitle,
        () => 1
    ),
    downloadFormat: format => {
        if (format === 'excel') {
            return 'excelPlus(omitTimestamp)(fileName=Depth)(indexField=index_depth)'
        } else if (format === 'csv') {
            return 'csvPlus(omitTimestamp)(fileName=Depth)(indexField=index_depth)'
        } else if (format === 'json') {
            return 'jsonPlus(fileName=Depth)'
        }
    }
})


